import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import { orchestrator } from 'satcheljs';
import { saveAction, updateAction } from '../data/actions/suggestedRepliesOptionActions';
import { updateUserConfiguration } from 'owa-options-core';

export default orchestrator(saveAction, async () => {
    // Save the option state in the userOptions store (session duration).
    const userConfiguration: OwaUserConfiguration = getUserConfiguration();
    const userOptions: UserOptionsType = userConfiguration && userConfiguration.UserOptions;

    // If user options not available, no need to process further, as we can't
    // update the backend.
    if (!userOptions) {
        return;
    }

    updateAction();

    // Update backend.
    await updateUserConfiguration([
        {
            propertyName: 'WebSuggestedRepliesEnabledForUser',
            propertyType: 'Boolean',
            propertyValue: `${userOptions.WebSuggestedRepliesEnabledForUser}`,
        },
    ]);
});
